// extracted by mini-css-extract-plugin
export default {"variationBlock":"variationBlock_variationBlock__k3b2S"};